<script setup lang="ts">
import authService, { SOCIAL_LOGIN_SERVICE } from '@/services/auth.service'

import googleImg from '@/assets/images/header/auth/google.svg'
import microsoftImg from '@/assets/images/header/auth/microsoft.svg'
import githubImg from '@/assets/images/header/auth/github.svg'
import cleverImg from '@/assets/images/header/auth/clevernew.png'

const props = defineProps({
  border: {
    type: Boolean,
    required: false,
    default: false
  }
})

interface ISocialLoginItem {
  name: string
  service: SOCIAL_LOGIN_SERVICE
  image: {
    src: string
    alt: string
  }
}

/**
 * @description Handle click on social login button
 * @param service - The social login service to use
 */
const handleSocialLogin = (service: SOCIAL_LOGIN_SERVICE): void => {
  authService.socialAuthentication(service)
}

const socialLoginItems: ISocialLoginItem[] = [
  {
    name: 'Google',
    service: SOCIAL_LOGIN_SERVICE.GOOGLE,
    image: {
      src: googleImg,
      alt: 'google'
    }
  },
  {
    name: 'Microsoft',
    service: SOCIAL_LOGIN_SERVICE.MICROSOFT,
    image: {
      src: microsoftImg,
      alt: 'microsoft'
    }
  },
  {
    name: 'Clever',
    service: SOCIAL_LOGIN_SERVICE.CLEVER,
    image: {
      src: cleverImg,
      alt: 'clever'
    }
  },
  {
    name: 'GitHub',
    service: SOCIAL_LOGIN_SERVICE.Github,
    image: {
      src: githubImg,
      alt: 'GitHub'
    }
  }
]
</script>

<template>
  <div class="flex flex-row flex-wrap justify-evenly gap-2">
    <button
      v-for="(items, index) of socialLoginItems"
      :key="index"
      @click="() => handleSocialLogin(items.service)"
      type="button"
      class="btn-rounded-md flex w-[45%] items-center justify-center hover:shadow-md sm:w-auto"
      :class="
        props.border &&
        ' border border-transparent hover:border-new-secondary-50 dark:hover:border-new-neutral-800 dark:hover:shadow-white/10'
      "
    >
      <img class="h-auto w-6 font-bold" :src="items.image.src" :alt="items.image.alt" />
      {{ items.name }}
    </button>
  </div>
</template>
